import styles from './GooglePlayStoreLink.module.scss';

import React, { AllHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';
import { stringify } from 'query-string';
import { usePlayStoreUrl } from 'hooks/usePlayStoreUrl';

type GooglePlayStoreLinkProps = Readonly<AllHTMLAttributes<HTMLAnchorElement> & {url?: string, children?: never}>;

const GA_PLAY_STORE_REFERRER = {
  referrer: stringify({
    utm_source: 'CWO',
    utm_medium: 'desktop_app_badge',
  }),
};

export const GooglePlayStoreLink: React.FC<GooglePlayStoreLinkProps> = ({ url: appUrl, className, ...props }) => {
  const { t } = useTranslation();

  const href = usePlayStoreUrl(appUrl, () => GA_PLAY_STORE_REFERRER);

  return (
    <a
      title={t('consumerAppFooter.playstore')}
      aria-label={t('consumerAppFooter.playstore')}
      className={cx(styles.playstore, className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      {...props}
    >
      {t('consumerAppFooter.playstore')}
    </a>
  );
};
